/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for UAUserAccount.
 *
 */

import { ReduxUtils } from '@spm/core';

const POST_ACES_SECRET_QUESTION_PASSWORD_RESET = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `UAUSERACCOUNT/POST_ACES_SECRET_QUESTION_PASSWORD_RESET`
);

export { POST_ACES_SECRET_QUESTION_PASSWORD_RESET };
